import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";

import Proptype from 'prop-types';

export const PageMeta = ({ title, children, removeDescriptionTag }) => {

    useEffect(() => {
        if (removeDescriptionTag) {
            // We need to remove current meta description tag, not the one created by Helmet
            const currentDescriptionTag = document.querySelector(`meta[name="description"]:not([data-react-helmet="true"])`);

            if (currentDescriptionTag) {
                document.head.removeChild(currentDescriptionTag);
            }
        }

    }, []);

    return (
        <Helmet>
            <title>{title}</title>
            {children}
        </Helmet>
    );
};

PageMeta.propTypes = {
    title: Proptype.string.isRequired,
    removeDescriptionTag: Proptype.bool,
    children: Proptype.any
};
export default PageMeta;
